import { useEffect, useCallback } from 'react'
import { useAppDispatch } from 'app/hooks'
import queryClient from 'app/queryClient'
import {
  useLiveReportLoginState,
  useLiveReportIsValidSession,
  useLiveReportCsrfTokenState
} from 'hooks/useLiveReportState'
import { getCsrfToken, login, logout } from 'features/liveReport/asyncThunks'
import { setIsValidSession, resetCsrfToken } from 'features/liveReport/liveReportSlice'

const useLiveReportAuth = () => {
  const dispatch = useAppDispatch()

  const loginState = useLiveReportLoginState()
  const isValidSession = useLiveReportIsValidSession()
  const csrfToken = useLiveReportCsrfTokenState()

  const retrieveCsrfToken = useCallback(() => {
    dispatch(getCsrfToken())
  }, [dispatch])
  const handleLogin = useCallback(
    ({ email, reportKey }: { email: string; reportKey: string }) => {
      dispatch(login({ email, reportKey }))
    },
    [dispatch]
  )
  const handleLogout = useCallback(() => {
    dispatch(logout())
  }, [dispatch])
  const notifySessionInvalid = useCallback(() => {
    dispatch(setIsValidSession(false))
  }, [dispatch])

  useEffect(() => {
    if (isValidSession === false) {
      queryClient.clear()
      dispatch(resetCsrfToken())
    }
  }, [isValidSession, dispatch])

  return {
    login: loginState,
    isValidSession,
    csrfToken,
    retrieveCsrfToken,
    handleLogin,
    handleLogout,
    notifySessionInvalid
  }
}

export default useLiveReportAuth
